@if (isBannerVisible()) {
  <div class="cleaning-banner fixed-bottom">
    <div class="cleaning-banner-content">
      <img
        src="/assets/svg/happy_logo.png"
        alt="Happy Helper Logo"
        class="happy-logo"
      />
      <div class="banner-text">
        <h3>Fast rengøring?</h3>
        <p>
          Få 100 kr til fast rengøring med HappyHelper med koden:
          <strong>{{ happyHelperCode }}</strong>
        </p>
        @if (codeCopiedMessageVisible()) {
          <p class="code-copied-message">
            Rabatkode kopieret! Du omdirigeres nu...
          </p>
        }
      </div>
      <button
        class="handyhand_button blue_button banner-button"
        (click)="copyCodeAndRedirect()"
      >
        Book nu
      </button>
      <button
        class="close-banner-button"
        (click)="closeBanner()"
        [attr.aria-label]="'Close Banner' | translate"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
}
